/* Display only: never change variant IDs, option values, SKU or print connections. */
(function () {
  'use strict';
  window.brFormatLabel = function (text) {
    return String(text).replace(/\b(A[0-4])\s*\(\s*(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm\)(?:\s*,?\s*(?:Vertical\s*\(portrait\)|Horizontal\s*\(landscape\))(?:\s*orientation)?)?/gi,
      function (_, size, width, height) {
        return size.toUpperCase() + ' (' + width.replace('.', ',') + ' × ' + height.replace('.', ',') + ' cm)';
      });
  };
}());
